import { render } from "./UpcomingeventPresentation.vue?vue&type=template&id=209cebb6&scoped=true"
import script from "./UpcomingeventPresentation.vue?vue&type=script&lang=js"
export * from "./UpcomingeventPresentation.vue?vue&type=script&lang=js"

import "./UpcomingeventPresentation.vue?vue&type=style&index=0&id=209cebb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209cebb6"]])

export default __exports__